export default function HeroSection() {
  return (
    <section className="relative h-screen min-h-[700px] w-full overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Elegant%20editorial%20flat%20lay%20photography%20featuring%20a%20carefully%20curated%20collection%20of%20modern%20fashion%20items%20including%20designer%20sneakers%20folded%20cashmere%20sweaters%20crisp%20cotton%20t-shirts%20leather%20accessories%20and%20a%20structured%20canvas%20tote%20bag%20all%20arranged%20in%20a%20harmonious%20grid%20composition%20on%20a%20warm%20cream%20textured%20surface%20with%20soft%20diffused%20natural%20window%20light%20casting%20delicate%20shadows%20high%20end%20editorial%20catalog%20aesthetic&width=1600&height=900&seq=hero-main-2026-v2&orientation=landscape"
        alt="OOPBuy Spreadsheet product sourcing collage"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/20" />
      <div className="relative z-10 h-full flex items-center w-full">
        <div className="w-full px-4 md:px-6 lg:px-16 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-10 pt-20">
          <div className="flex flex-col gap-6 lg:max-w-[55%]">
            <div className="flex items-center gap-3">
              <div className="flex -space-x-2">
                <div className="w-10 h-10 rounded-full border-2 border-white/80 overflow-hidden">
                  <img src="https://readdy.ai/api/search-image?query=Closeup%20studio%20product%20photograph%20of%20a%20white%20minimalist%20leather%20sneaker%20on%20a%20clean%20neutral%20light%20backdrop%20with%20soft%20even%20studio%20lighting%20minimalist%20catalog%20style%20high%20detail&width=80&height=80&seq=avatar-a1-v2&orientation=squarish" alt="" className="w-full h-full object-cover" />
                </div>
                <div className="w-10 h-10 rounded-full border-2 border-white/80 overflow-hidden">
                  <img src="https://readdy.ai/api/search-image?query=Closeup%20studio%20product%20photograph%20of%20a%20soft%20gray%20cashmere%20sweater%20folded%20on%20a%20clean%20neutral%20light%20backdrop%20with%20soft%20even%20studio%20lighting%20minimalist%20catalog%20style%20high%20detail&width=80&height=80&seq=avatar-a2-v2&orientation=squarish" alt="" className="w-full h-full object-cover" />
                </div>
                <div className="w-10 h-10 rounded-full border-2 border-white/80 overflow-hidden">
                  <img src="https://readdy.ai/api/search-image?query=Closeup%20studio%20product%20photograph%20of%20a%20tan%20leather%20crossbody%20bag%20on%20a%20clean%20neutral%20light%20backdrop%20with%20soft%20even%20studio%20lighting%20minimalist%20catalog%20style%20high%20detail&width=80&height=80&seq=avatar-a3-v2&orientation=squarish" alt="" className="w-full h-full object-cover" />
                </div>
              </div>
              <span className="text-white/90 text-sm font-medium">Trusted by 10,000+ resellers</span>
            </div>
            <div className="flex flex-col">
              <h1 className="font-heading text-[56px] md:text-[72px] lg:text-[80px] leading-[0.95] font-light text-white tracking-tight">
                OOPBuy
              </h1>
              <span className="font-sans text-[56px] md:text-[72px] lg:text-[80px] leading-[0.95] font-extrabold text-white tracking-tighter">
                Spreadsheet
              </span>
            </div>
            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="flex items-center justify-center gap-2 h-14 px-8 rounded-full bg-white text-foreground-950 font-semibold text-base whitespace-nowrap cursor-pointer hover:bg-background-100 transition-colors duration-200"
              >
                Explore oopbuy spreadsheet
                <i className="ri-arrow-right-line text-lg"></i>
              </a>
            </div>
          </div>
          <div className="lg:max-w-[380px] bg-white/10 backdrop-blur-xl border border-white/20 rounded-2xl p-6">
            <p className="text-white/90 text-base leading-relaxed font-light">
              The OOPBuy Spreadsheet is a powerful data-tracking workflow system designed for serious product resellers. Streamline inventory management, automate restock monitoring, and organize thousands of SKUs across 14 specialized categories.
            </p>
          </div>
        </div>
      </div>
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-white/40 rounded-full flex items-start justify-center p-1.5">
          <div className="w-1 h-2.5 bg-white/60 rounded-full animate-bounce" />
        </div>
      </div>
    </section>
  );
}